export default __webpack_public_path__ + "day-stork-bg-2560x1600.be224a6.svg";